import React from "react";
import "./App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import Login from "./Pages/Auth/Login";
import { useAuth } from "./Context/AuthContext";
import AdminLayout from "./layouts/AdminLayout/AdminLayout";
import Overview from "./Pages/Overview/Overview";
import Approvals from "./Pages/Approvals/Approvals";
import StudyReview from "./Pages/Approvals/StudyReview";
import StudyApproved from "./Pages/Approvals/StudyApproved";
import Researchers from "./Pages/Researchers/Researchers";
import ResearcherProfile from "./Pages/Researchers/ResearcherProfile";
import Participants from "./Pages/Participants/Participants";
import ParticipantProfile from "./Pages/Participants/ParticipantProfile";
import Verification from "./Pages/Verification/Verification";
import DocReview from "./Pages/Verification/DocReview";
import Payments from "./Pages/Payments/Payments";
import PayoutBatch from "./Pages/Payments/PayoutBatch";
import FailedPayouts from "./Pages/Payments/FailedPayouts";
import Support from "./Pages/Support/Support";
import TicketDetail from "./Pages/Support/TicketDetail";
import Safety from "./Pages/Safety/Safety";
import FraudCase from "./Pages/Safety/FraudCase";
import Revenue from "./Pages/Revenue/Revenue";
import EditPricing from "./Pages/Revenue/EditPricing";
import Notifications from "./Pages/Notifications/Notifications";
import SendNotification from "./Pages/Notifications/SendNotification";
import Team from "./Pages/Team/Team";
import Settings from "./Pages/Settings/Settings";

function App() {
  const { isLoggedIn, login } = useAuth();

  React.useEffect(() => {
    const token = localStorage.getItem("token");
    const storedUser = localStorage.getItem("userInfo");

    if (token && storedUser && !isLoggedIn) {
      try {
        login(token, JSON.parse(storedUser));
      } catch (e) {
        console.error("Failed to parse userInfo from localStorage", e);
      }
    }
  }, [isLoggedIn, login]);

  return (
    <BrowserRouter>
      <Routes>
        <Route path="/login" element={<Login />} />
        <Route element={<AdminLayout />}>
          <Route path="/" element={<Overview />} />
          <Route path="/overview" element={<Overview />} />
          <Route path="/approvals" element={<Approvals />} />
          <Route path="/study-review" element={<StudyReview />} />
          <Route path="/study-approved" element={<StudyApproved />} />
          <Route path="/researchers" element={<Researchers />} />
          <Route path="/researcher-profile" element={<ResearcherProfile />} />
          <Route path="/participants" element={<Participants />} />
          <Route path="/participant-profile" element={<ParticipantProfile />} />
          <Route path="/verification" element={<Verification />} />
          <Route path="/doc-review" element={<DocReview />} />
          <Route path="/payments" element={<Payments />} />
          <Route path="/payout-batch" element={<PayoutBatch />} />
          <Route path="/failed-payouts" element={<FailedPayouts />} />
          <Route path="/support" element={<Support />} />
          <Route path="/ticket-detail" element={<TicketDetail />} />
          <Route path="/safety" element={<Safety />} />
          <Route path="/fraud-case" element={<FraudCase />} />
          <Route path="/revenue" element={<Revenue />} />
          <Route path="/edit-pricing" element={<EditPricing />} />
          <Route path="/notifications" element={<Notifications />} />
          <Route path="/send-notification" element={<SendNotification />} />
          <Route path="/team" element={<Team />} />
          <Route path="/settings" element={<Settings />} />
          <Route path="*" element={<Navigate to="/" replace />} />
        </Route>
      </Routes>
    </BrowserRouter>
  );
}

export default App;
